import { useEffect, useState } from 'react'

import { useNavigate } from 'react-router'
import { fetchSingle } from 'src/legacy_modules/entities/template/request'
import { routes } from 'src/legacy_modules/routes'

import { useTemplateEntities } from '../../template-entities-context'

export const useFetch = ({
  trialUid,
  templateUid,
  pathForNotFound,
}: {
  trialUid: string
  templateUid: string
  pathForNotFound: string
}) => {
  const [fetched, setFetched] = useState(false)
  const navigate = useNavigate()
  const { upsertTemplate } = useTemplateEntities()

  useEffect(() => {
    let cancelled = false

    const run = async () => {
      try {
        const template = await fetchSingle({ trialUid, templateUid })
        if (cancelled) return
        upsertTemplate(template)
        setFetched(true)
      } catch (error) {
        if (cancelled) return
        console.error('fetchSingle Error: ', error)
        if (error?.original?.response?.status === 404) {
          navigate(pathForNotFound)
        } else if (error?.original?.response?.status === 403) {
          navigate(routes.httpError403)
        } else {
          navigate(`${routes.requiredLogin}`)
        }
      }
    }

    run()

    return () => {
      cancelled = true
    }
  }, [navigate, pathForNotFound, templateUid, trialUid, upsertTemplate])

  return {
    fetched,
  }
}
